<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        class="d-flex align-center w-auto"
        v-on="flat ? {} : on"
      >
        <v-img
          contain
          width="25px"
          height="25px"
          :alt="orderData[labelType]"
          :src="orderData.icon"
        />
        <span v-if="flat" class="ml-1 font-weight-medium text-black">{{
          orderData.label
        }}</span>
      </span>
    </template>
    <span>{{ orderData[labelType] }}</span>
  </v-tooltip>
</template>

<script>
  import { getOrderTypeMetaByDoctype } from '@/core/constants/orderDoctypeMetadataConstants';

  export default {
    name: 'OrderTypeTooltip',

    props: {
      value: {
        type: String,
        required: true,
      },

      labelType: {
        type: String,
        default: 'label',
        validator: (value) =>
          ['label', 'longLabel', 'productLabel'].includes(value),
      },

      // Shows label inline
      flat: Boolean,
    },

    computed: {
      orderData() {
        return getOrderTypeMetaByDoctype(this.value);
      },
    },
  };
</script>
